module.exports = __webpack_public_path__ + "static/media/imgparkrun04.6c0bc05c.jpg";